import axios from 'axios'
import _ from 'lodash'
import Serializer from '@/lib/orderSerializer'
import * as types from '../mutation-types'

function updatePrices ({ state, commit, getters }) {
  /* eslint-disable */
  // Ensure items array exists and is not empty
  const items = state.items || []
  console.log('updatePrices called with items:', items)
  console.log('Items length:', items.length)
  let prices = items.reduce((memo, item) => {
    console.log('Processing item in reduce:', item)
    console.log('Item price:', item?.price)
    // Add null checks to prevent errors when items or price is undefined
    if (!item || !item.price) {
      console.log('Skipping item due to missing price structure:', item)
      return memo
    }
    console.log('Adding item prices:', item.price.total, item.price.discounted)
    return {
      total: memo.total + (item.price.total || 0),
      discounted: memo.discounted + (item.price.discounted || 0)
    }
  }, {
    total: 0,
    discounted: 0
  })
  console.log('Prices calculated:', prices)
  console.log('Getters country:', getters.country)
  console.log('State multiple:', state.multiple)
  let deliveryPrice = state.multiple ? (getters.country?.price || 0) : (getters.country?.single_pr_price || 0)
  if (getters.pickup || (getters.country?.free_limit > -1 && getters.country?.free_limit < prices.discounted)) {
    deliveryPrice = 0
  }
  prices.delivery = deliveryPrice
  const paymentAmountType = getters.paymentAmountType
  if (paymentAmountType && paymentAmountType.discount > 0) {
    if (getters.paymentType.label === 'Paypal') {
      prices.discounted = prices.discounted / 100 * (100 - 0)
    } else {
      prices.discounted = prices.discounted / 100 * (100 - paymentAmountType.discount)
    }
  }
  // if cart is empty, update delivery price
  if (items.length === 0) {
    prices.delivery = 0
  }
  if (prices.total === 0) {
    commit(types.SET_MONTAGE_STATUS, false)
    commit(types.SET_MONTAGE_COST, 0)
  }
  commit(types.SET_PRICES, prices)
}
export const state = {
    orderId: null,
    checkoutId: null,
    orderSending: false,
    discount: 20, // discount percent for 'anzahlung
    items: [],
    lastPurchaseData: null,
    countries: null,
    country: 'Deutschland',
    pickup: false,
    price: {
      discounted: 0,
      total: 0,
      delivery: 0
    },
    customer: {
      additional: '',
      differentDeliveryAddress: false,
      address: {
        name: '',
        company: '',
        phone: '',
        email: '',
        street: '',
        zip: '',
        city: ''
      },
      deliveryAddress: {
        name: '',
        company: '',
        phone: '',
        email: '',
        street: '',
        zip: '',
        city: '',
      }
    },
    paymentAmount: {
      selected: 1,
      types: [
        {
          id: 1,
          name: 'Anzahlung 20%',
          label: '20% Anzahlung vom Auftragsvolumen',
          sublabel: 'exkl. eventueller Montagekosten',
          tooltip: {
            image: null,
            text: 'Bei der Bestellung wird eine Anzahlung in Höhe von 20% der Auftragssumme fällig. Ohne Montage: Bei Lieferbereitschaft ggf. am Tag der Lieferung sind die restlichen 80% der Auftragssumme fällig. Mit Montage: Bei Lieferbereitschaft ggf. am Tag der Lieferung sind 70% der Auftragssumme fällig. Die verbleibende 10% erst wenn die Montage abgeschlossen wurde'
          },
          discount: 0,
          prepayment: 20,
          customer_discount: null
        },
        // {
        //   id: 2,
        //   name: 'Ich zahle den gesamten Betrag (Skonto -1%)',
        //   label: 'Bei dieser Zahlungsart ist die Zahlung per PayPal nicht möglich.',
        //   sublabel: '2% Ersparnis auf die gesamte Rechnung',
        //   discount: 2,
        //   prepayment: 0,
        //   customer_discount: 'Bei Skontozahlung sparen Sie'
        // },
      ],
    },
    payment: {
      selected: 1,
      types: [
        {
          id: 1,
          label: 'Überweisung',
          icon: '',
          disabled: false,
          description: 'Die Anzahlung wird auf unser Konto überwiesen. Bereits unmittelbar nach Abschluss Ihrer Bestellung senden wir Ihnen per Mail unsere Bankverbindung.'
        },
        {
          id: 2,
          label:'Paypal',
          icon: 'https://www.loewe-zaun.de/wp-content/uploads/2023/01/PayPalpng.png',
          disabled: false,
          description: 'Die Weiterleitung zu Paypal erfolgt am Ende des Bestellvorganges zur Zahlungsabwicklung.',
          tooltip: {
            image: null,
            text: 'PayPal kann für Anzahlungen bis 1.000,00 EUR kostenfrei genutzt werden. Darüber hinausgehende Zahlungen werden mit der PayPal-Provisionsgebühr in Höhe von 1,9% beim Kunden kalkuliert.'
          }
        },
        // mollie
        {
          id: 3,
          label:'Mollie',
          icon: 'https://loewe-zaun.de/wp-content/uploads/2025/08/Secure-payments-powered-by-Mollie-Cards-PayPal-Sofort__2x.png',
          disabled: false,
          description: 'Unsere Transaktionen werden über den Zahlungsanbieter Mollie abgewickelt.',
          tooltip: {
            image: null,
            text: 'Zahlungen per Kreditkarte oder Sofortüberweisung wickeln wir zuverlässig über den Zahlungsanbieter Mollie ab.'
          }
        },
        //{id: 3, label: 'Sofort', icon: 'https://cdn.klarna.com/1.0/shared/image/generic/badge/de_de/pay_now/descriptive/pink.svg', description: 'Customers who want to pay in full at checkout can do it quickly and securely with Klarnas Pay now-option - using credit/debit card or Direct bank transfer: Klarna Direkt, Sofort, SEPA Direct Debit.'},
      ],
      guarantee: false,
    },
    url: null,
    montageCost: null,
    montageStatus: false,
    montageBonus: 0,
    promocode: {
      status: false,
      discount: 0,
      total: 0,
      id: '',
      code: ''
    },
    multiple: true,
    additionalOptions: [
      {
        label: 'Mit Kran Abladen',
        price: 50,
        selected: false,
        tooltip: {
          image: null,
          text: 'Sie werden mit einem LKW ausgeliefert, welches ein Kran an Board hat. Sie brauchen also keine Abladehilfe zu stellen, wir laden das Tor selbst ab.'
        }
      }
    ]
}
// getters
export const getters = {
  items: state => state.items,
  price: state => state.price,
  countries: state => state.countries,
  country: state => {
    if (state.countries) {
      return state.countries.find(c => c.name === state.country)
    }
  },
  pickup: state => state.pickup,
  customerAddress: state => state.customer.address,
  deliveryAddress: state => state.customer.deliveryAddress,
  differentDeliveryAddress: state => state.customer.differentDeliveryAddress,
  customerAdditional: state => state.customer.additional,
  customer: state => state.customer,

  payment: state => state.payment,
  paymentType: state => state.payment.types.find(p => p.id === state.payment.selected),

  paymentAmount: state => state.paymentAmount,
  paymentAmountType: state => state.paymentAmount.types.find(t => t.id === state.paymentAmount.selected),

  orderId: state => state.orderId,
  checkoutId: state => state.checkoutId,

  orderSending: state => state.orderSending,
  url: state => state.url,
  montageCost: state => state.montageCost,
  montageStatus: state => state.montageStatus,
  montageBonus: state => state.montageBonus,
  multiple: state => state.multiple,
  promocode: state => state.promocode,
  additionalOptions: state => state.additionalOptions,
  lastPurchaseData: state => state.lastPurchaseData
}
// actions
export const actions = {
  addItem (context, item) {
  	console.log('addItem called with item:', item)
  	console.log('Item price:', item?.price)
  	// Ensure item has proper structure before adding
  	if (!item || !item.price) {
  		console.warn('addItem: Item missing price structure', item)
  		return
  	}
  	console.log('Item validation passed, adding to cart')
  	context.commit(types.CHANGE_TYPE_OF_CART, true)
  	context.commit(types.ADD_ITEM_TO_CART, _.cloneDeep(item))
  	console.log('Item added, calling updatePrices')
  	updatePrices(context)
  },
  addProduct (context, item) {
  	// Ensure item has proper structure before adding
  	if (!item || !item.price) {
  		console.warn('addProduct: Item missing price structure', item)
  		return
  	}
  	context.commit(types.CHANGE_TYPE_OF_CART, false)
  	context.commit(types.ADD_ITEM_TO_CART, _.cloneDeep(item))
  	updatePrices(context)
  },
  removeItem (context, id) {
    context.getters.items.splice(context.getters.items.findIndex(el => {
      return el.id === id
    }), 1)
    // update montage
    context.commit(types.SET_MONTAGE_BONUS, 0)
    context.commit(types.SET_ITEMS, context.getters.items)
    updatePrices(context)
  },
  changeQty (context, id) {
  	const option = context.state.items.find(o => o.id === id)
  	let p = 0
    // const d = 0
    const oldPrice = Number.parseFloat(option.price.old_price)
    const qty = Number.parseInt(option.quantity)
    let discount = 0
    let totalDiscount = 0
    const disc = Number.parseInt(option.discount)
    p = oldPrice * qty
    discount = disc / 100 * oldPrice
    totalDiscount = (oldPrice * qty) - discount
    option.price.total = p
    option.price.discounted = totalDiscount
    updatePrices(context)
  },
  selectDelivery (context, countryName) {
  	context.commit(types.SET_DELIVERY_COUNTRY, countryName)
  	updatePrices(context)
  },
  selectPaymentAmount (context, id) {
  	context.commit(types.SET_SELECTED_PAYMENT_AMOUNT, id)
  	updatePrices(context)
  },
  updatePickup (context, pickup) {
  	context.commit(types.SET_PICKUP, pickup)
  	updatePrices(context)
  },
  changePaymentType (context) {
  	updatePrices(context)
  },
  changePayment (context, val) {
    context.commit(types.SET_SELECTED_PAYMENT, val)
    updatePrices(context)
  },
  async order (context) {
    context.commit(types.SET_ORDER_ID, null)
    context.commit(types.SET_CHECKOUT_ID, null)
  	context.commit(types.SET_ORDER_SENDING, true)
  	const serializer = new Serializer(context)
    const apiUrl = process.env.VUE_APP_API_URL
  	await axios.post(apiUrl + 'checkout', { order: serializer.serialize() }).then(res => {
      if (res.data && res.data.orderId) {
        // Save purchase data for tracking before clearing cart
        const purchaseData = {
          items: [...context.state.items],
          price: { ...context.state.price },
          customer: { address: { ...context.state.customer.address } },
          paymentType: context.getters.paymentType,
          pickup: context.state.pickup,
          country: context.getters.country,
          promocode: context.state.promocode
        }
        context.commit(types.SET_LAST_PURCHASE_DATA, purchaseData)
        context.commit(types.SET_ORDER_ID, res.data.orderId)
        context.commit(types.SET_CHECKOUT_ID, res.data.id)
        context.commit(types.SET_ORDER_SENDING, false)
        context.commit(types.TRUNCATE_CART)
        context.commit(types.SET_PROMOCODE, { status: false, discount: 0, total: 0, id: '', code: '' })
      }
    })
  },

  async setDeliveryCountries (context) {
    const apiKey = btoa(process.env.VUE_APP_API_KEY)
    const apiUrl = process.env.VUE_APP_API_URL
    await axios.post(apiUrl + 'configs/all', { re: apiKey, name: 'deliveries' }).then(resp => {
      if (resp.data !== null) {
        const data = JSON.parse(resp.data.value)
        context.commit(types.SET_COUNTRIES, data)
      }
    })
  },
  setPromocode (context, promocode) {
    context.commit(types.SET_PROMOCODE, promocode)
  },
  clearPromocode (context) {
    context.commit(types.SET_PROMOCODE, { status: false, discount: 0, total: 0, id: '', code: '' })
  },
  setAdditionalOption (context, item) {
    if (item.selected) {
      context.state.price.total += Number.parseInt(item.price)
      context.state.price.discounted += Number.parseInt(item.price)
    } else {
      context.state.price.total -= Number.parseInt(item.price)
      context.state.price.discounted -= Number.parseInt(item.price)
    }
    updatePrices(context);
  },
  setMontageCost(context, payload) {
    context.commit(types.SET_MONTAGE_COST, payload)
  },
  setMontageStatus(context, payload) {
    context.commit(types.SET_MONTAGE_STATUS, payload)
  }
}
// mutations
export const mutations = {
  [types.RESET] (state) {
    state.items = []
    state.price = {
      discounted: 0,
      total: 0,
      delivery: 0
    }
  },
  [types.ADD_ITEM_TO_CART] (state, item) {
  	state.items.push(item)
  },
  [types.SET_ITEMS] (state, items) {
  	state.items = items
  },
  [types.SET_DELIVERY_COUNTRY] (state, country) {
  	state.country = country
  },
  [types.SET_COUNTRIES] (state, countries) {
    state.countries = countries
  },
  [types.SET_PRICES] (state, prices) {
  	state.price = prices
  },
  [types.SET_PICKUP] (state, pickup) {
  	state.pickup = pickup
  },
  [types.SET_SELECTED_PAYMENT_AMOUNT] (state, id) {
  	state.paymentAmount.selected = id
  },
  [types.TOGGLE_DIFFERENT_ADDRESS] (state) {
  	state.customer.differentDeliveryAddress = !state.customer.differentDeliveryAddress
  },
  [types.SET_ORDER_SENDING] (state, status) {
  	state.orderSending = status
  },
  [types.SET_ORDER_ID] (state, id) {
  	state.orderId = id
  },
  [types.SET_CHECKOUT_ID] (state, id) {
  	state.checkoutId = id
  },
  [types.TRUNCATE_CART] (state) {
  	state.items = []
  },
  [types.SET_URL] (state, url) {
  	state.url = url
  },
  [types.UPDATE_URL] (state) {
  	state.url = null
  },
  [types.SET_MONTAGE_COST] (state, cost) {
  	state.montageCost = cost
  },
  [types.SET_MONTAGE_STATUS] (state, status) {
  	state.montageStatus = status
  },
  [types.CHANGE_TYPE_OF_CART] (state, status) {
  	state.multiple = status
  },
  [types.SET_MONTAGE_BONUS] (state, bonus) {
    state.montageBonus = bonus
  },
  [types.SET_PROMOCODE] (state, promocode) {
    state.promocode = promocode
  },
  [types.SET_SELECTED_PAYMENT] (state, value) {
    const item = state.payment.types.find(t => t.id === value.item)
    item.disabled = value.disabled
    // Don't reset the selected payment type - let the user's selection persist
  },
  [types.SET_LAST_PURCHASE_DATA] (state, data) {
    state.lastPurchaseData = data
  }
}
